import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { organizationJobfeedForPartnerAutoCompleteInput$, organizationJobfeedForPartnerAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const OrganizationJobfeedForPartnerAutoSuggest = renderAutoSuggestWithOptions(
   organizationJobfeedForPartnerAutoCompleteObservable$,
   organizationJobfeedForPartnerAutoCompleteInput$,
);

OrganizationJobfeedForPartnerAutoSuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   filterOrganization: {
      id: null,
      name: '',
   },
   forceSelection: false,
   placeholder: 'Search Organization...',
};

export default OrganizationJobfeedForPartnerAutoSuggest;
